const SESSION_STORAGE_KEY = "logged_in";
const SESSION_USER = "1";
const SESSION_GUEST = "0";

const authenticate = (logged: boolean) => {
  try {
    if (logged) {
      document.body.classList.remove("session-guest");
      document.body.classList.add("session-user");
    } else {
      document.body.classList.remove("session-user");
      document.body.classList.add("session-guest");
    }
  } catch (e) {
    return;
  }
};

const getStoredSession = () => {
  try {
    return window.localStorage.getItem(SESSION_STORAGE_KEY);
  } catch {
    return null;
  }
};

const authenticateFromStorage = () => {
  const session = getStoredSession();

  if (session === SESSION_USER) {
    authenticate(true);
  }

  if (session === SESSION_GUEST) {
    authenticate(false);
  }
};

const saveSession = (logged: boolean) => {
  try {
    window.localStorage.setItem(
      SESSION_STORAGE_KEY,
      logged ? SESSION_USER : SESSION_GUEST
    );
  } catch {
    return;
  }
};

const initSession = () => {
  const iframe = document.createElement("iframe");
  iframe.src = `${CONFIG.ssoHost}/session`;
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  window.addEventListener("message", event => {
    if (event.origin === CONFIG.ssoHost) {
      authenticate(event.data.loggedIn);
      saveSession(event.data.loggedIn);
    }
  });
};

authenticateFromStorage();

Defer(initSession, 3000, true);
